import React from "react";
import PropTypes from "prop-types";

import styles from "./LoadProducts.module.scss";
import GenericFormContainer from "../../../../helpers/GenericFormContainer";
import AdminLayout from "../../../../components/MainApp/layouts/DesktopLayout";
import LoadButtonsContainer from "../../../../components/MainApp/organisms/Product/LoadButtonsContainer";
import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

export class LoadProductsView extends GenericFormContainer {
  headerOptions = [
    {
        icon: 'icon-iconos_categorìas',
        name: 'categories',
        handler: () => { this.props.history.push('/admin/categories') },
        tooltip: capitalize(i18n.t("categories"))
    },
  ]

  goBack(){
      this.props.history.push('/admin/products')
  }

  render() {
    const content = <div className={styles["load-products-content"]}>
        <LoadButtonsContainer
          handleSingleProductClick={() => this.props.history.push('/admin/products/load-single-product')}
          handleMassiveProductClick={() => this.props.history.push('/admin/products/load-massive-product')}
        ></LoadButtonsContainer>
    </div>;

    return (
      <div className={styles["load-products-container"]}>
        <AdminLayout headerTitle={i18n.t("products")} headerOptions={this.headerOptions}
            content={content} goBackFunc={this.goBack.bind(this)}>
        </AdminLayout>
      </div>
    );
  }
}

LoadProductsView.propTypes = {
  handleChange: PropTypes.func,
  label: PropTypes.string,
};

export default LoadProductsView;
